import Button from "@/components/Button";
import Dialog from "@/components/Dialog";
import KeyboardShortcutHint from "@/components/KeyboardShortcutHint";
import type { KeyboardShortcutEntry } from "@/lib/keyboardShortcutCatalog";

type KeyboardShortcutsDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  entries: KeyboardShortcutEntry[];
};

function ShortcutEntryRow({ description, hints }: KeyboardShortcutEntry) {
  return (
    <div className="flex items-center justify-between gap-4 py-2">
      <span className="text-body-medium text-sys-brand-on-surface">{description}</span>
      <div className="flex items-center gap-1 shrink-0">
        {hints.map((hint, index) => (
          <span key={`${hint.keyLabel}-${index}`} className="flex items-center gap-1">
            {index > 0 ? <span className="text-label-small text-sys-brand-on-surface-variant">then</span> : null}
            <KeyboardShortcutHint {...hint} />
          </span>
        ))}
      </div>
    </div>
  );
}

export default function KeyboardShortcutsDialog({ open, onOpenChange, entries }: KeyboardShortcutsDialogProps) {
  return (
    <Dialog
      open={open}
      onClosed={() => onOpenChange(false)}
      headline="Keyboard Shortcuts"
      className="w-[min(560px,calc(100vw-2rem))] p-6 pr-2"
      actions={
        <Button variant="filled" onClick={() => onOpenChange(false)} data-testid="keyboard-shortcuts-dialog-close">
          Close
        </Button>
      }
    >
      <div className="max-h-[min(60vh,480px)] overflow-y-auto pr-4 divide-y divide-sys-brand-outline-variant">
        {entries.map((entry) => (
          <ShortcutEntryRow key={entry.description} {...entry} />
        ))}
      </div>
    </Dialog>
  );
}
